/**
 * The logo mark.
 *
 * This renders the supplied artwork rather than a drawing of it, so the mark in
 * the header is the same image as the one on the letterhead. The files are
 * generated by scripts/build_logo.py from src/assets/image.png; see
 * public/brand/README.md.
 *
 * The mark is 371x311, so it is not square — pass a height and let the width
 * follow, or it will stretch.
 */

/** Native aspect of the mark artwork, used to derive width from height. */
const ASPECT = 371 / 311;

export function LogoMark({
  height = 40,
  reversed = false,
  title,
  className,
}: {
  height?: number;
  /** Navy is invisible on a dark background; this swaps in the light artwork. */
  reversed?: boolean;
  /** Omit when a visible wordmark sits beside it — the link labels itself. */
  title?: string;
  className?: string;
}) {
  return (
    <img
      className={["logo-mark", className].filter(Boolean).join(" ")}
      src={reversed ? "/brand/logo-mark-reversed.png" : "/brand/logo-mark.png"}
      width={Math.round(height * ASPECT)}
      height={height}
      alt={title ?? ""}
      aria-hidden={title ? undefined : true}
      decoding="async"
    />
  );
}
